<section *ngFor="let comment of sortedComments" [ngClass]="styles.wrapper">
	<video-comment [ngClass]="styles.comment" [comment]="comment" (onToggleRepliesDisplay)="toggleRepliesDisplay($event)">
	</video-comment>

	<section [hidden]="!comment.showReplies" [ngClass]="styles.childCommentWrapper" *ngFor="let childComment of comment.childComments">
		<video-comment [ngClass]="styles.comment" [comment]="childComment">
		</video-comment>
	</section>

</section>
